/*
=========================================================
* LexGo - Yapım Aşamasında
=========================================================
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";

// Lex Go components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKSocialButton from "components/MKSocialButton";

// Images
import logoLexGo from "assets/images/logo-ct-dark.png";

function ComingSoon() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        // action'ı kaldırdım; istersen WhatsApp/CTA koyarız
        sticky
      />
      <MKBox
        minHeight="100vh"
        sx={{
          backgroundColor: "#0E1525", // 🔥 Arka plan rengi (lacivert ton). İstersen değiştir.
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={8} textAlign="center">
              {/* Logo */}
              <MKBox component="img" src={logoLexGo} alt="LexGo Logo" width="120px" mb={3} />

              {/* Başlık */}
              <MKTypography variant="h2" color="white" fontWeight="bold" gutterBottom>
                Yapım Aşamasında 🚧
              </MKTypography>

              {/* Açıklama */}
              <MKTypography variant="h6" color="white" mb={4}>
                LexGo çok yakında yayında olacak. Güncellemeler için bizi sosyal medyadan takip
                edin.
              </MKTypography>

              {/* Sosyal medya */}
              <Grid container justifyContent="center" spacing={2}>
                <Grid item>
                  <MKSocialButton
                    component="a"
                    href="https://www.instagram.com/lexgo.hukuk/"
                    target="_blank"
                    color="instagram"
                  >
                    <i className="fab fa-instagram" />
                  </MKSocialButton>
                </Grid>
                <Grid item>
                  <MKSocialButton
                    component="a"
                    href="https://www.tiktok.com/@lexgo04"
                    target="_blank"
                    color="dark"
                  >
                    <i className="fab fa-tiktok" />
                  </MKSocialButton>
                </Grid>
                <Grid item>
                  <MKSocialButton
                    component="a"
                    href="https://www.linkedin.com/in/lexgo-hukuk-829900381/"
                    target="_blank"
                    color="linkedin"
                  >
                    <i className="fab fa-linkedin" />
                  </MKSocialButton>
                </Grid>
                <Grid item>
                  <MKSocialButton
                    component="a"
                    href="https://x.com/LexgoHukuk"
                    target="_blank"
                    color="twitter"
                  >
                    <i className="fab fa-twitter" />
                  </MKSocialButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
}

export default ComingSoon;
